/// Este componente se comporta como un modal, que recibe como children el contenido que se va a mostrar ///

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { createPortal } from "react-dom";
import Translate from "../../i18n/Translate";

import Logo from "../../assets/images/static/Logo.svg";

const Modals = ({ isVisible, hideModal, children, confirmation, overflow }) => {
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => (document.body.style.overflow = "auto");
  }, [isVisible]);

  return isVisible
    ? createPortal(
        <div
          className={confirmation ? "modals confirmation" : "modals"}
          style={overflow ? { overflow: "auto" } : { overflow: "hidden" }}
        >
          <div className="modals__container">
            <div className="modals__header">
              <span></span>

              {!confirmation && (
                <Link
                  to="/"
                  // to={`${language}${t("routes.home")}`}
                  className="header__content__logo"
                >
                  <img loading="auto" src={Logo} alt="Tower Sports" />
                </Link>
              )}

              <div className="modals__header__button">
                {!confirmation && (
                  <>
                    <p>
                      <Translate langkey="globals.close" />
                    </p>
                    <button onClick={hideModal}>
                      <svg
                        className="ham hamRotate ham1 active"
                        viewBox="0 0 100 100"
                        width="100"
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                      >
                        <path
                          className="line top"
                          d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
                        />
                        <path className="line middle" d="m 30,50 h 40" />
                        <path
                          className="line bottom"
                          d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
                        />
                      </svg>
                    </button>
                  </>
                )}
              </div>
            </div>

            {children}
          </div>
        </div>,
        document.body
      )
    : null;
};

export default Modals;
